import { FeatureToggle, NotificationResource } from '../../types';
import { DealerInfo } from '../../types/DealerInfo';
import { GetAllDataFromPath } from '../api/GenericClient';
import { processNotifications } from '../utils/NotificationUtils';

async function fetchNotifications(
  isConquestEnabled: boolean,
  isPrimaryUser: boolean,
  featureToggle: FeatureToggle,
  storeCode: string,
  dealerInfos: DealerInfo[],
  isIncentiveAdvantageType: boolean,
  isEssentialWithTransUnion: boolean,
  isTransUnionEnabled: boolean,
): Promise<NotificationResource[]> {
  const url = `/common/notifications?isConquestEnabled=${isConquestEnabled}`;
  const response = await GetAllDataFromPath<NotificationResource[]>(url);
  return processNotifications(
    response,
    isPrimaryUser,
    featureToggle,
    storeCode,
    dealerInfos,
    isIncentiveAdvantageType,
    isEssentialWithTransUnion,
    isTransUnionEnabled,
  );
}

export const NotificationService = {
  fetchNotifications,
};
